/**
 * IMPORTANT - BLOCKCHAIN DATA INTEGRITY:
 * This file handles blockchain data which must maintain exact values and case sensitivity.
 * - NEVER use toLowerCase() or toUpperCase()
 * - NEVER normalize strings or addresses
 * - NEVER transform collection names
 * - NEVER modify contract addresses
 * - ALWAYS use exact matches for comparisons
 * - ALWAYS preserve original data as it exists on-chain
 */

// Collection addresses for supported NFT collections - EXACT on-chain addresses
export const COLLECTION_ADDRESSES = {
    'CryptoPunks': '0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb',
    'Bored Ape Yacht Club': '0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d',
    'Mutant Ape Yacht Club': '0x60e4d786628fea6478f785a6d7e704777c86a7c6',
    'Azuki': '0xed5af388653567af2f388e6224dc7c4b3241c544',
    'CLONE X': '0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b',
    'Doodles': '0x8a90cab2b38dba80c64b7734e58ee1db38b8992e',
    'Moonbirds': '0x23581767a106ae21c074b2276d25e5c3e136a68b',
    'Meebits': '0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7',
    'Pudgy Penguins': '0xbd3531da5cf5857e7cfaa92426877b022e612cf8',
    'Cool Cats': '0x1a92f7381b9f03921564a437210bb9396471050c',
    'World of Women': '0xe785e82358879f061bc3dcac6f0444462d4b5330',
    'Autoglyphs': '0xd4e4078ca3495de5b1d4db434bebc5a986197782',
    'VeeFriends': '0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb',
    'CyberKongz': '0x57a204aa1042f6e66dd7730813f4024114d74f37',
    'PROOF Collective': '0x08d7c0242953446436f34b4c78fe9da38c73668d',
    'Invisible Friends': '0x59468516a8259058bad1ca5f8f4bff190d30e066',
    'Wrapped Cryptopunks': '0x282bdd42f4eb70e7a9d9f40c8fea0825b7f68c5d'
};

// Top NFT collections by volume/popularity - EXACT on-chain names
export const TOP_COLLECTIONS = Object.keys(COLLECTION_ADDRESSES);

// Constants for special collections
export const CRYPTOPUNKS_ADDRESS = COLLECTION_ADDRESSES['CryptoPunks'];
export const WPUNKS_ADDRESS = COLLECTION_ADDRESSES['Wrapped Cryptopunks']; 